




































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import Button from '@/app/ui/components/Button/index.vue'
import FileInput from '@/app/ui/components/FileInput/index.vue'
import controller, {
  Dropdown,
} from '@/app/ui/controllers/DriverAnnouncementController'
import { EventBus, EventBusConstants, Utils } from '@/app/infrastructures/misc'
import Modal from '@/app/ui/components/Modal/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import DateTimePicker from '@/app/ui/components/DateTimePicker/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import dayjs from 'dayjs'

interface Form {
  announcementTitle: string
  announcementBody: string
  announcementImage?: string | null
  startAt: string
  endAt: string
  location: Dropdown[]
  courierTypeValid: Dropdown | null
  ctaName?: string
  ctaUrl?: string
}

@Component({
  mixins: [validationMixin],
  components: {
    TextInput,
    Button,
    FileInput,
    Modal,
    LoadingOverlay,
    DateTimePicker,
    DropdownSelect,
  },
})
export default class CreateDriverAnnouncementPage extends Vue {
  controller = controller
  form: Form = {
    announcementTitle: '',
    announcementBody: '',
    announcementImage: null,
    startAt: '',
    endAt: '',
    location: [],
    courierTypeValid: controller.constant.courierTypeOptions.find(
      option => option.value === 'ALL'
    ) as Dropdown,
    ctaName: '',
    ctaUrl: '',
  }
  confirmationModal = false
  successModal = false

  created(): void {
    EventBus.$on(EventBusConstants.CREATE_DRIVER_ANNOUNCEMENT_SUCCESS, () => {
      this.confirmationModal = false
      this.successModal = true
    })

    controller.getDistrictList()
  }

  @Validations()
  validations(): Record<string, any> {
    return {
      form: {
        announcementTitle: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(70),
        },
        announcementBody: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(2000),
        },
        startAt: {
          required,
        },
        endAt: {
          required,
        },
      },
    }
  }

  get courierTypeOptions(): Dropdown[] {
    return controller.constant.courierTypeOptions
  }

  get districtOptions(): Dropdown[] {
    return controller.districts
  }

  private async changeImage(file: File) {
    const image = await controller.uploadImage(file)

    this.form.announcementImage = image as string
  }

  private createAnnouncement() {
    controller.createAnnouncement({
      announcementTitle: this.form.announcementTitle,
      announcementBody: this.announcementBody,
      announcementImage: this.form.announcementImage,
      startAt: dayjs(this.form.startAt || '').toISOString(),
      endAt: dayjs(this.form.endAt || '').toISOString(),
      location:
        this.form.location.length === 0
          ? 'ALL'
          : this.form.location.map(location => location.value).join(','),
      courierTypeValid: this.form.courierTypeValid
        ? this.form.courierTypeValid?.value
        : 'ALL',
    })
  }

  get announcementBody(): string {
    let body = Utils.escapeHTML(this.form.announcementBody).replace(
      /(?:\r\n|\r|\n)/g,
      '<br/>'
    )

    if (this.form.ctaUrl || this.form.ctaName) {
      const style = [
        'background-color: #d11f40',
        'border: none',
        'color: white',
        'padding: 10px 32px',
        'text-align: center',
        'text-decoration: none',
        'display: inline-block',
        'font-size: 16px',
        'margin: 4px 2px',
        'cursor: pointer',
        'border-radius: 8px',
        'font-weight: 500',
      ]
      body += `<br/><br/><div style="text-align: center"><a style="${style.join(
        ';'
      )}" href="${this.form.ctaUrl}">${this.form.ctaName ||
        this.form.ctaUrl}</a></div>`
    }

    return body
  }

  private onCloseSuccessModal() {
    this.successModal = false
    this.$router.push({ name: 'DriverAnnouncementList' })
  }

  get isUploading(): boolean {
    return controller.isUploading
  }

  get today(): string {
    return dayjs().format('YYYY-MM-DD[T]HH:mm:ss.SSS')
  }

  beforeDestroy(): void {
    EventBus.$off(EventBusConstants.CREATE_DRIVER_ANNOUNCEMENT_SUCCESS)
  }
}
